var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfersSelectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23196_16540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0008 14C20.2557 14.0003 20.5009 14.0979 20.6862 14.2728C20.8715 14.4478 20.9831 14.6869 20.998 14.9414C21.013 15.1958 20.9302 15.4464 20.7666 15.6418C20.603 15.8373 20.3709 15.9629 20.1178 15.993L20.0008 16H6.41485L8.70785 18.293C8.88719 18.4729 8.99132 18.7144 8.99907 18.9684C9.00683 19.2223 8.91763 19.4697 8.7496 19.6603C8.58156 19.8508 8.34729 19.9703 8.09437 19.9944C7.84145 20.0185 7.58884 19.9454 7.38785 19.79L7.29385 19.707L3.46385 15.877C2.79885 15.213 3.22485 14.094 4.12685 14.006L4.24185 14H20.0008ZM15.2938 4.29298C15.466 4.12081 15.6951 4.01738 15.9382 4.00209C16.1812 3.98681 16.4214 4.06073 16.6138 4.20998L16.7078 4.29298L20.5378 8.12298C21.2028 8.78698 20.7768 9.90598 19.8748 9.99398L19.7598 9.99998H4.00085C3.74597 9.9997 3.50081 9.9021 3.31548 9.72714C3.13014 9.55217 3.01861 9.31303 3.00367 9.05859C2.98874 8.80415 3.07152 8.5536 3.23511 8.35815C3.3987 8.1627 3.63075 8.03709 3.88385 8.00698L4.00085 7.99998H17.5868L15.2938 5.70698C15.1064 5.51946 15.0011 5.26515 15.0011 4.99998C15.0011 4.73482 15.1064 4.48051 15.2938 4.29298Z",
    fill: "#610D24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23196_16540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfersSelectedIcon);
export default __webpack_public_path__ + "static/media/transfers_selected_icon.ee48850a9a4f09ef86ea1d009328b0f1.svg";
export { ForwardRef as ReactComponent };